export class Alert {
    type: AlertType;
    message: string;
    isOpen ?: boolean;
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning,
    WarningSpecial,
    ErrorWithoutTimeout
}